var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.events
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: { type: "list-item-avatar-three-line" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.events
        ? _c(
            "v-expansion-panels",
            {
              attrs: { accordian: "", flat: "", focusable: "" },
              model: {
                value: _vm.panel,
                callback: function ($$v) {
                  _vm.panel = $$v
                },
                expression: "panel",
              },
            },
            _vm._l(_vm.events, function (item, index) {
              return _c(
                "v-expansion-panel",
                {
                  key: item.id,
                  class: ["mb-2 mt-0", `panel-${index}`],
                  attrs: { disabled: "" },
                },
                [
                  _c(
                    "v-expansion-panel-header",
                    {
                      class: ["soli-round mb-2 pa-0 click-events"],
                      attrs: {
                        "expand-icon": "keyboard_arrow_down",
                        disabled: !!_vm.clickedLessonDetails,
                      },
                      on: {
                        click: function ($event) {
                          _vm.clickedLessonDetails = item.id
                        },
                      },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          class: [
                            "align-center",
                            item.cancelled ? "grey-text" : "soli-grey",
                          ],
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "col-3 flex justify-center" },
                            [
                              _c("SoliStatusAvatar", {
                                attrs: {
                                  event: item,
                                  showGroupStatus: item.type == "Event",
                                  purchaseOption:
                                    item.student?.attendance.purchase_option,
                                  noShadow: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { staticClass: "pl-0" },
                            [
                              _c("v-list", { staticClass: "mx-2" }, [
                                _c("div", { staticClass: "caption" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(`${_vm.globalMomentFullDateAtTimeShort(
                                        item.starts_at
                                      )} · ${item.duration} min
                                                `) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                !item.group_event
                                  ? _c("div", [
                                      _vm.can("View statistical reports")
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.$vuetify.breakpoint
                                                  .xsOnly
                                                  ? "body-2"
                                                  : "body-1",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.student?.name) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "caption" },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      item.instrument.name
                                                    ) +
                                                    "\n                                        · " +
                                                    _vm._s(item.teacher.name) +
                                                    " ·\n                                        " +
                                                    _vm._s(item.room.title) +
                                                    " ·\n                                        " +
                                                    _vm._s(
                                                      item.online
                                                        ? "Online"
                                                        : "In-studio"
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.$vuetify.breakpoint
                                                  .xsOnly
                                                  ? "body-2"
                                                  : "body-1",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.type) +
                                                    " w/\n                                        " +
                                                    _vm._s(item.student.name) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "caption" },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      item.instrument.name
                                                    ) +
                                                    "\n                                        · " +
                                                    _vm._s(item.location.name) +
                                                    " ·\n                                        " +
                                                    _vm._s(item.room.title) +
                                                    " ·\n                                        " +
                                                    _vm._s(
                                                      item.online
                                                        ? "Online"
                                                        : "In-studio"
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ])
                                  : _c("div", [
                                      _c(
                                        "div",
                                        {
                                          class: _vm.$vuetify.breakpoint.xsOnly
                                            ? "body-2"
                                            : "body-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.group_event.title) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "caption" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.teacher.name) +
                                            " ·\n                                    " +
                                            _vm._s(item.room.title) +
                                            " ·\n                                    " +
                                            _vm._s(
                                              item.online
                                                ? "Online"
                                                : "In-studio"
                                            ) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "v-row",
                        { staticClass: "justify-around align-center py-5" },
                        [
                          _c(
                            "v-btn",
                            { attrs: { icon: "", small: "", color: "dark" } },
                            [
                              _c("v-icon", [_vm._v("change_circle")]),
                              _vm._v(" "),
                              _c("small", { staticClass: "mt-1 panel-text" }, [
                                _vm._v("Reschedule"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            { attrs: { icon: "", small: "", color: "dark" } },
                            [
                              _c("v-icon", [_vm._v("cancel")]),
                              _vm._v(" "),
                              _c("small", { staticClass: "mt-1 panel-text" }, [
                                _vm._v("Cancel"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.getPaymentStatus(item) &&
                          _vm.can("Manage user locations")
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "", color: "dark" },
                                },
                                [
                                  _c("v-icon", [_vm._v("mail_outline")]),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass: "mt-1 panel-text",
                                      staticStyle: { "white-space": "normal" },
                                    },
                                    [_vm._v("Payment Link")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.getPaymentStatus(item)
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "", color: "dark" },
                                },
                                [
                                  _c("v-icon", [_vm._v("add_task")]),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass: "mt-1 panel-text",
                                      staticStyle: { "white-space": "normal" },
                                    },
                                    [_vm._v("Attendance")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clickedLessonDetails
        ? _c("LessonDetail", {
            ref: "details",
            attrs: {
              errors: _vm.$page.props.errors,
              auth: _vm.$page.props.auth,
              lessonId: _vm.clickedLessonDetails,
            },
            on: {
              reset: function ($event) {
                _vm.clickedLessonDetails = null
              },
              success: _vm.handleSuccess,
              rescheduleLesson: function ($event) {
                ;[
                  (_vm.clickData = $event),
                  (_vm.bookingForm = true),
                  (_vm.clickedLessonDetails = null),
                ]
              },
              showMessage: function ($event) {
                return _vm.$emit("success")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.bookingForm
        ? _c("CreateLesson", {
            attrs: {
              errors: _vm.errors,
              event: _vm.clickData,
              bookingSource: {
                isNew: false,
                isCalendar: false,
                isMySchedule: false,
                isReschedule: true,
              },
            },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.bookingForm = false))
              },
              success: _vm.handleSuccess,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }